import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import type { ProductType } from "shared/products/domain/productType";
import { useProductGroupStore } from "shared/products/groups/stores/productGroupStore";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import type { ProductGroupResponse } from "./productGroupResponse";

export interface CreateProductGroupRequest {
  group: ProductGroup;
}

interface ProductGroup {
  name: string;
  description: string;
  productType: ProductType;
  color: string | null;
}

export interface CreateProductGroupSucessResponse {
  ok: true;
  group: ProductGroupResponse;
}

export function useCreateProductGroup() {
    const httpClient = useHttpClient();
    const languageStore = useLanguageStore();
    const { translations } = storeToRefs(languageStore);
    const store = useProductGroupStore();

    return {
      execute
    };

    async function execute(action: CreateProductGroupRequest) {
      const {
        group,
      } = action;

      const headers = httpClient.defaultHeaders();
      const request = new Request(httpClient.siteUrl('product/group'), {
        method: 'POST',
        headers,
        body: JSON.stringify(group)
      });

      const text = translations.value.productGroups.actions.create;

      const response = await httpClient.action<CreateProductGroupSucessResponse>(request, {
        title: text.title,
        errorTitle: text.error,
        async processOk(response) {
          const json = await response.json() as ProductGroupResponse;
          store.add(json);
          return {
            ok: true,
            group: json
          };
        },
      });

      return response;
    }
}
